<script lang="ts">
    import Select from "svelte-select"
    import { filterConfig } from "./config"
    import { _ } from "svelte-i18n"
    export let filter: PriceCalculationExceptionFilter
    // Zwei getrennte Zustände, weil der Typ je nach Attribut unterschiedlich
    // ist (Mehrfachauswahl vs. Zahlenfeld). Ein gemeinsamer Union-Wert ließ
    // sich im Template nicht sauber verengen.
    let arrayValue: { label: string; value: string | number }[] = []
    let numberValueObj: { label: string; value: string | number } = { label: "", value: null }

    const isArrayValue = !!filterConfig[filter.attribute]?.options

    if (isArrayValue) {
        arrayValue = filter.stringArrayValues
            ? filter.stringArrayValues.map((val) => ({
                  label: filterConfig[filter.attribute]?.options?.[val]?.de || val,
                  value: val,
              }))
            : []
    } else {
        numberValueObj = {
            label: filter.numberValue ? filter.numberValue.toString() : "",
            value: filter.numberValue,
        }
    }
    $: if (
        isArrayValue &&
        !(
            filter.stringArrayValues.length === arrayValue.length &&
            filter.stringArrayValues.every((val, index) => val == arrayValue[index].value)
        )
    )
        filter.stringArrayValues = arrayValue.map((val) => val.value as string)
    else if (!isArrayValue) filter.numberValue = numberValueObj.value as number
</script>

{#if isArrayValue}
    <Select
        placeholder=" {$_('general.lookForValue')}"
        items="{Object.entries(filterConfig[filter.attribute || 'installationType'].options).map(([key, value]) => ({
            label: value.de,
            value: key,
        }))}"
        multiple="{true}"
        clearable="{false}"
        showChevron="{true}"
        placeholderAlwaysShow="{true}"
        required="{true}"
        bind:value="{arrayValue}"
    ></Select>
{:else}
    <div class="inputholder has-append no-input-margin">
        <input
            class="with-label-size"
            required="{true}"
            type="number"
            step="0.01"
            min="0"
            placeholder="0"
            bind:value="{numberValueObj.value}"
        />
        <div class="input-append">
            {#if filter?.attribute?.toLowerCase()?.includes("price")}
                €
            {:else}
                {$_("general.units")}
            {/if}
        </div>
    </div>
{/if}
